import {
  AppBar,
  Box,
  makeStyles,
  Theme,
  Toolbar,
  Typography
} from '@material-ui/core';
import { KitchenDisplay } from 'kiolyn-api';
import React, { FC, Fragment } from 'react';
import { isNull, isNumber } from 'util';
import KitchenDisplayInteraction from './KitchenDisplayInteraction';
import { DSOrder } from './StatusTypeList.stories';

const useStyles = makeStyles((theme: Theme) => {
  const tbHeight = isNumber(theme.mixins.toolbar.minHeight)
    ? theme.mixins.toolbar.minHeight
    : 0;

  return {
    container: {
      maxWidth: '100%',
      width: '100%',
      margin: 0,
      overflowY: 'auto',
      overflowX: 'hidden',
      height: `calc(100% - ${tbHeight + theme.spacing(3)}px)`,
      marginTop: theme.spacing(1)
    },
    menuTitle: {
      flexGrow: 1,
      lineHeight: 1.2,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      marginLeft: theme.spacing(2)
    }
  };
});

interface KitchenDisplayProps {
  kitchenDisplay?: KitchenDisplay;
  orders?: DSOrder[];
  onStatusChanged?: (order: DSOrder) => void;
}

const KitchenDisplayVM: FC<KitchenDisplayProps> = ({
  kitchenDisplay,
  orders,
  onStatusChanged
}: KitchenDisplayProps) => {
  const classes = useStyles();

  return (
    <Fragment>
      <AppBar key="appBar" position="sticky">
        <Toolbar>
          <Typography variant="h6" className={classes.menuTitle}>
            {isNull(kitchenDisplay)
              ? 'Kitchen Display not found'
              : kitchenDisplay?.name}
          </Typography>
        </Toolbar>
      </AppBar>
      <Box className={classes.container}>
        <KitchenDisplayInteraction
          kitchenDisplay={kitchenDisplay}
          orders={orders}
          onStatusChanged={onStatusChanged}
        />
      </Box>
    </Fragment>
  );
};

export default KitchenDisplayVM;
